import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9169149e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "testimonial-viewport" }
const _hoisted_2 = { class: "testimonial-track" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = {
  class: "pagination",
  "aria-label": "Pagination"
}
const _hoisted_7 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "testimonial-slider",
    style: _normalizeStyle({ '--items': _ctx.itemsToShow })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
        class: "nav edge left desktop-nav",
        "aria-label": "Previous"
      }, "←"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
        class: "nav edge right desktop-nav",
        "aria-label": "Next"
      }, "→"),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all, (t, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["testimonial", { hidden: i < _ctx.currentIndex || i >= _ctx.currentIndex + _ctx.itemsToShow }]),
            key: `testimonial-${i}`
          }, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(t.name), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(t.text), 1)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
          class: "nav left",
          "aria-label": "Previous"
        }, "←"),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (_, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              class: _normalizeClass(['dot', { active: i === _ctx.currentPage }]),
              onClick: ($event: any) => (_ctx.goToPage(i)),
              "aria-label": `Go to page ${i + 1}`
            }, null, 10, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
          class: "nav right",
          "aria-label": "Next"
        }, "→")
      ])
    ])
  ], 4))
}